import { InjectionToken, Type } from '@angular/core';
/**
 * @abstract
 */
export abstract class PresetType {
private __isPreset__ = true;
}

function PresetType_tsickle_Closure_declarations() {
/** @type {?} */
PresetType.prototype.__isPreset__;
}


export const /** @type {?} */ PRESET_TYPES_TOKEN = new InjectionToken<PresetType[]>(
  'PresetTypes',
);
export const /** @type {?} */ PRESET_COMPS_TOKEN = new InjectionToken<Type<any>[][]>(
  'PresetComps',
);
